import SectionHeader from './SectionHeader';
import { CAPABILITIES, SITE } from '../config/site';

export default function CapabilitiesSection({ limit, compact = false }) {
  const items = limit ? CAPABILITIES.slice(0, limit) : CAPABILITIES;

  return (
    <section className={`section capabilities-section${compact ? ' capabilities-section--compact' : ''}`}>
      <div className="container">
        <SectionHeader
          creative
          light
          align={compact ? 'center' : 'left'}
          label="Capabilities"
          title={compact ? 'How we deliver' : 'Engineering depth across the stack'}
          description={
            compact
              ? `${SITE.shortName} combines product ownership with AI-native engineering and multi-cloud operations.`
              : 'From MQTT brokers to GenAI copilots — we apply the same production discipline we use running our own platforms.'
          }
        />
        <div className="capabilities-grid">
          {items.map((item) => (
            <article key={item.id} className="capability-card capability-card--enterprise">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
